import styled from "styled-components";

export default styled.div`
cursor: pointer;
    width: 156px;
        height: 52px;
      flex-grow: 1;
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
      gap: 10px;
      padding: 20px 0;
      border-radius: 8px;
      background-color: #263628;
        
  font-family: "Pretendard";
  font-size: 16px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: 0.2px;
  text-align: center;
  color: #fff;
  
  flex-grow: unset;
    `